<div class="waving-hand-animation" [style.animation-duration]="animationDuration"></div>